import { BaseRemittanceNewMember } from './base-remittance-new-member';

export class ScheduledRemittanceNewMember extends BaseRemittanceNewMember {
  public scheduledRemittanceId!: number;
}
